import { render, staticRenderFns } from "./telNum.vue?vue&type=template&id=33f41524&scoped=true&"
import script from "./telNum.vue?vue&type=script&lang=js&"
export * from "./telNum.vue?vue&type=script&lang=js&"
import style0 from "./telNum.vue?vue&type=style&index=0&id=33f41524&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f41524",
  null
  
)

export default component.exports